document.addEventListener("DOMContentLoaded", function() {
  console.log("✅ RSNL global.js loaded");

  // Loader safeguard
  setTimeout(function() {
    document.body.classList.add("loaded");
    var loader = document.getElementById("loader");
    if (loader) loader.style.display = "none";
    console.log("✅ Loader released");
  }, 2000);

  // Example sticky header
  window.addEventListener("scroll", function() {
    const header = document.querySelector('.main-header');
    if (header) {
      if (window.scrollY > 50) {
        header.classList.add('sticky');
      } else {
        header.classList.remove('sticky');
      }
    }
  });
});
